import { Base64ToObject } from '../serializers/serializer-utils';

export function GetEncodedValueFromSession(key: string) {
  const encodedData = window.sessionStorage.getItem(btoa(key));

  if (!encodedData) return undefined;

  return Base64ToObject<string>(encodedData);
}
